export function radiansToDegrees(radians: number) {
  return radians * (180 / Math.PI);
}
export function degreesToRadians(degrees: number) {
  return degrees * (Math.PI / 180);
}
